


















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import { decimalFormat } from '@/helpers/decimalFormat';
import FadeTwin from '@/components/UI/fade-twin.vue';
import {
  UNIT_ML_ID,
} from '@/settings/consts/prescription-params';

@Component({
  components: { FadeTwin },
})
export default class PrescriptionResumeProducts extends BaseComponent {
  @Prop()
  public data: any;

  @Prop()
  public isTranscriptions: boolean;

  public getFadeTwinLabel(id): string {
    return 'prod' + id;
  }

  public getUnitTyped(units): any {    
    const unit = units.find((item) => {
      return item.digitado;
    });
    return unit || {};
  }

   public mounted(): void {
     if (this.isTranscriptions) {
        this.compararTranscricoes();
     }
   }

   public updated(): void {
     if (this.isTranscriptions) {
       this.compararTranscricoes();
     }
   }


  public decimalFormat(val): string {
    return decimalFormat(val);
  }
  public compararTranscricoes(){
    var elementosProductsResume =  document.querySelectorAll(`.dim-twin:not(.data-item):not(.caracteristica-item)`);
    var labels = [];
    elementosProductsResume.forEach((i) =>
       labels.push(i.getAttribute("data-label"))
    );
    var itensComparacao;
    for (const nome in labels) {
       itensComparacao = document.querySelectorAll(`[data-label="${labels[nome]}"]`)
       // produtos que tem nas duas transcrições.. (dos dois lados, compara as duas)
        if(itensComparacao !== undefined && itensComparacao.length > 1){
          // Produtos que estão dos dois lados e estão diferentes..
          if(itensComparacao[0].querySelector('.product-item-value').textContent !=
              itensComparacao[1].querySelector('.product-item-value').textContent ){
                document
                .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
                .forEach((i) => i.classList.add('colorDiff'));
          }
          // Produtos que estão dos dois lados, porém não há diferença
          else{
              document
                .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
                .forEach((i) => i.classList.remove('colorDiff'));
          }
       // produtos que so tem numa das transcrições.. (só tem 1 vez)
       } else if (itensComparacao !== undefined && itensComparacao.length === 1){
          document
          .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
          .forEach((i) => i.classList.add('colorDiff'));
       }
    }
  }
}
